import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { TextField } from '@finam/web-ui-kit';
import styled from 'styled-components';
export var TextFieldStyled = styled(TextField)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 16px;\n\n  & > p {\n    white-space: pre-wrap;\n  }\n"])));
export default TextFieldStyled;